import React, { useContext, useEffect, useState } from 'react'
import { Shopcontext } from '../context/Shopcontext'
import Title from '../components/Title';
import { assets } from '../assets/assets';
import Carttotal from '../components/Carttotal';

const Cart = () => {
    const { products, currency, cartItems, updateQuantity, navigate } = useContext(Shopcontext);
    const [cartData, setCartData] = useState([]);

    useEffect(() => {
        if (products.length > 0) {
            let tempdata = [];
            for (const items in cartItems) {
                for (const item in cartItems[items]) {
                    if (cartItems[items][item] > 0) {
                        tempdata.push({
                            _id: items,
                            size: item,
                            quantity: cartItems[items][item]
                        })
                    }
                }
            }
            setCartData(tempdata);
        }
    }, [cartItems, products])



    return (
        <div className='border-t pt-14'>
            <div className='text-2xl mb-3'>
                <Title text1={"YOUR"} text2={"CART"} />
            </div>
            <div className=''>
                {
                    cartData.map((item, index) => {
                        const ProData = products.find(product => product._id === item._id)
                        return (
                            <div key={index} className='py-4 border-t border-b text-gray-700 grid grid-cols-[4fr_0.5fr_0.5fr] sm:grid-cols-[4fr_2fr_0.5fr] items-center gap-4 shadow-custom rounded-xl my-2'>
                                <div className='flex items-start gap-6'>
                                    <img src={ProData.image[0]} alt="" className='w-16 sm:w-20' />
                                    <div>
                                        <p className='text-xs sm:text-lg font-medium'>{ProData.name}</p>
                                        <div className='flex items-center gap-5 mt-2'>
                                            <p >{currency}{ProData.price}</p>
                                            <p className='px-2 sm:px-3 sm:py-1 border bg-slate-50'>{item.size}</p>
                                        </div>
                                    </div>
                                </div>

                                <input className='border max-w-10 sm:max-w-20 px-1 sm:px-2 py-1 mx-3 ' type="number" min={1} defaultValue={item.quantity} onChange={(e) => e.target.value === "" || e.target.value === '0' ? null : updateQuantity(item._id, item.size, Number(e.target.value))
                                } />

                                <img onClick={() => { updateQuantity(item._id, item.size, 0) }} className='w-5 cursor-pointer' src={assets.bin_icon} alt="" />
                            </div>
                        )
                    })
                }
            </div>
            <div className='flex justify-end my-20'>
                <div className='w-full sm:w-[450px] '>
                    <Carttotal />
                    <div className='w-full text-end'>
                        <button onClick={() => navigate('/place-order')} className='bg-black rounded-full shadow-custom text-white text-sm my-8 px-8 py-3'>PROCEED TO CHECKOUT</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cart